module.exports = __webpack_public_path__ + "static/media/logo-christmas.6d4bbf48.png";